import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';
import { finalize } from 'rxjs/internal/operators/finalize';

import { LoadingOverlayService } from '../services/loading-overlay.service';

// URL prefixes that should not trigger the global loading bar.
const SKIP_PREFIXES = ['/events/', '/socket.io'];

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private _loadingService: LoadingOverlayService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (SKIP_PREFIXES.some(prefix => request.url.includes(prefix))) {
      return next.handle(request);
    }

    this._loadingService.increment();
    return next.handle(request).pipe(
      finalize(() => this._loadingService.decrement())
    );
  }
}
